import React from 'react';
import { COMPANY_CONTACT } from '../../constants/contact';

const ContactInfo = () => {
  return (
    <section className="mb-8">
      <h2 className="text-xl font-semibold text-gray-800 mb-4">Contact Information</h2>
      <ul className="space-y-2 text-gray-600">
        <li><strong>Email:</strong> {COMPANY_CONTACT.email}</li>
        <li><strong>Phone:</strong> {COMPANY_CONTACT.phone}</li>
        <li><strong>Address:</strong> {COMPANY_CONTACT.address.street}, {COMPANY_CONTACT.address.postalCode} {COMPANY_CONTACT.address.city}, {COMPANY_CONTACT.address.country}</li>
      </ul>
    </section>
  );
};

export default ContactInfo;